export const VIEW = {
  MAIN: 'main',
  INVERT: 'invert',
  SECONDARY: 'secondary',
  LINE: 'line',
}

export const SIZE = {
  S: 's',
  M: 'm',
}

export const STATE = {
  DEFAULT: 'default',
  LOADING: 'loading',
  DISABLED: 'disabled',
}
